import { Box, Card, CardContent, Typography, useTheme } from "@mui/material";

interface MasterCardsProps {
  titleActive: string;
  titleInactive: string;
  countActive: number;
  countInactive: number;
}

const MasterCard: React.FC<MasterCardsProps> = ({
  titleActive,
  titleInactive,
  countActive,
  countInactive,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ height: "auto", width: "100%", display: "flex", gap: 3 }}>
      <Card
        sx={{
          p: 1,
          width: "50%",
          border: `1px solid ${theme.palette.primary.main}`,
        }}
      >
        <CardContent>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "500",
              color: "#000",
              fontSize: "0.8rem",
            }}
          >
            {titleActive}
          </Typography>
          <Typography variant="h1" sx={{ fontSize: "2rem", mt: 1 }}>
            {countActive || 0}
          </Typography>
        </CardContent>
      </Card>
      <Card sx={{ p: 1, width: "50%", border: "1px solid #ED6F2D" }}>
        <CardContent>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "500",
              color: "#000",
              fontSize: "0.8rem",
            }}
          >
            {titleInactive}
          </Typography>
          <Typography
            variant="h1"
            sx={{ fontSize: "2rem", mt: 1 }}
            color="#ED6F2D"
          >
            {countInactive || 0}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MasterCard;
